<template lang="pug">
v-container.px-sm-8.py-sm-4
  .mb-2
  v-row(no-gutters)
    v-col
      v-tabs(v-model="tab" height="44")
        v-tab.text-sm.text-capitalize(active-class="font-semibold") Status
        v-tab.text-sm.text-capitalize(active-class="font-semibold") Reject Reason
    v-col
      .d-flex.align-center
        v-spacer
        v-btn.button-sm.ml-2(color="primary" depressed @click="clickNew") {{ $t('new') }}
  v-divider

  v-tabs-items(v-model="tab")
    v-tab-item
      status-list(ref="statusChild")
    v-tab-item
      reject-reason-list(ref="rejectChild")

</template>

<script>
import StatusList from './StatusList.vue'
import RejectReasonList from './RejectReasonList.vue'
import AddStatusDialog from '@/components/connect/dialogs/AddStatusDialog.vue'
import EditStatusDialog from '@/components/connect/dialogs/EditStatusDialog.vue'
import DeleteStatusDialog from '@/components/connect/dialogs/DeleteStatusDialog.vue'

export default {
  name: 'Status',
  components: { StatusList, RejectReasonList, AddStatusDialog, EditStatusDialog, DeleteStatusDialog },
  data: () => ({
    tab: 0,
  }),
  methods: {
    clickNew() {
      if (this.tab === 0) {
        this.$refs.statusChild?.addStatus()
      } else {
        this.$refs.rejectChild?.addRejectReason()
      }
    }
  }
}
</script>
